var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarightarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4818 7.71905L9.38553 13.5383C9.03915 13.85 8.51957 13.85 8.20783 13.5036C7.89609 13.1572 7.89609 12.6377 8.24247 12.3259L12.8493 7.92688H1.07237C0.587434 7.92688 0.241053 7.5805 0.241053 7.09557C0.241053 6.64527 0.587434 6.26425 1.07237 6.26425H12.8493L8.24247 1.89984C7.89609 1.5881 7.89609 1.03389 8.20783 0.722146C8.51957 0.375764 9.07378 0.375764 9.38553 0.687508L15.4818 6.50672C15.655 6.67991 15.7589 6.88774 15.7589 7.09557C15.7589 7.33803 15.655 7.54586 15.4818 7.71905Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarightarrow);
export default __webpack_public_path__ + "static/media/calendarightarrow.f8991ad29be5f5f0d9ef31d9d84d0920.svg";
export { ForwardRef as ReactComponent };